import { FormControl } from "@material-ui/core";
import styled from "styled-components";

const OccurrenceFilterControl = styled(FormControl).attrs({
  variant: "outlined",
  size: "small"
})`
  min-width: 160px;
`;

export default OccurrenceFilterControl;
